import { getEnvironmentConfig } from "./firebase";

const LIST_VIDEOS_URLS = {
  dev: "https://us-central1-tennis-uploader-dev.cloudfunctions.net/listUserVideos",
  stg: "https://us-central1-tennis-uploader-stg.cloudfunctions.net/listUserVideos",
  prod: "https://us-central1-tennis-uploader.cloudfunctions.net/listUserVideos",
};

const recentVideoRequests = new Map();

function getListVideosUrl() {
  const projectId = getEnvironmentConfig().projectId || "tennis-uploader";
  if (projectId.includes("stg")) return LIST_VIDEOS_URLS.stg;
  if (projectId.includes("dev")) return LIST_VIDEOS_URLS.dev;
  return LIST_VIDEOS_URLS.prod;
}

async function requestUserVideos(token) {
  const response = await fetch(getListVideosUrl(), {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });

  if (!response.ok) {
    throw new Error(`Unable to load videos (${response.status})`);
  }

  const result = await response.json();
  return Array.isArray(result) ? result : [];
}

export function loadRecentUserVideos(user, { force = false } = {}) {
  if (!user?.uid) {
    return Promise.reject(new Error("Sign in to load your videos."));
  }

  if (!force && recentVideoRequests.has(user.uid)) {
    return recentVideoRequests.get(user.uid);
  }

  const request = user
    .getIdToken()
    .then(requestUserVideos)
    .catch((error) => {
      recentVideoRequests.delete(user.uid);
      throw error;
    });

  recentVideoRequests.set(user.uid, request);
  return request;
}

export function prefetchRecentUserVideos(user) {
  if (!user?.uid || recentVideoRequests.has(user.uid)) return;

  loadRecentUserVideos(user).catch((error) => {
    console.warn("Recent video prefetch failed:", error);
  });
}
